module.exports = __webpack_public_path__ + "fonts/Gibson-SemiBoldItalic.862e697d.woff2";